import {
  type OfferShippingsV1,
  type OfferV11,
} from '@redteclab/api/clients/bully'

const priorityShippings = ['standard', 'express', 'sameday', 'spedition']

export const shippingAccessorGetShippingByPriority = (
  offer: OfferV11,
): OfferShippingsV1 | undefined => {
  if (!offer.seller) {
    return undefined
  }

  for (const shippingType of priorityShippings) {
    const sellerShipping = offer.shippings?.find(
      (shipping) => shipping.shippingTypeCode === shippingType,
    )

    if (sellerShipping) {
      return sellerShipping
    }
  }

  return undefined
}
